//===============================================================
//  LOADING
//===============================================================

// LOADING SCREEN
const loadingFinTime = 600;
const loadingTag = '#nowloading';
function showLoading(show_flag) {
	if(show_flag){
		//console.log("LOADING画面オープン")
		//Tween24.prop(loadingTag).style("display", "block").opacity(0).play();
		//Tween24.tween(loadingTag, 0.3).opacity(1).play();
		
		$(loadingTag).css({"display":"block","opacity":0});
		//$(loadingTag).delay(0).animate({'opacity':1}, {'duration': 5.3});
		
		/* gsap.to(loadingTag, {opacity: 1, duration: 0.5, delay: 0, onComplete: () => {
			console.log("開いた")
		}}); */

		gsap.to(loadingTag, {autoAlpha: 1, duration: 0.2, overwrite: true, onComplete: () => {}});

	}else{
		//console.log("LOADING画面クローズ")
		//console.log("IMG LOAD OK - PAGE READY CHECK START")
		if(!pageLoadFlag){
			//console.log("PAGE READY CHECK - pageLoadFlag : false")
			let civCount = 0;
			const civ = setInterval(function(){
				//console.log("pageLoadFlag",pageLoadFlag,"civCount",civCount)
				if(pageLoadFlag){
					clearInterval(civ);
					loadingFinAnimeFunc();
				}else{
					civCount++;
					//console.log("civCount",civCount)
					if(civCount > 40){
						//console.log("LOADING TIME OVER")
						pageLoadFlag = true;
					}
				}
			}, 100);
		}else{
			//console.log("PAGE READY CHECK - pageLoadFlag : true")
			loadingFinAnimeFunc();
		}
	}
}
const loadingFinAnimeFunc = function(){
	//console.log("loadingFinAnimeFunc()")
	/* $(loadingTag).stop(true).delay(100).animate({'opacity':0}, {'duration':loadingFinTime, 'complete':function(){
		$(this).css({'display':'none'});
		initAnime_Page();
	}}); */

	gsap.to(loadingTag, {autoAlpha: 0, duration: (loadingFinTime * 0.001), delay: 0.3, ease: "power4.out", onComplete: () => {
		initAnime_Page();
	}});

	/* gsap.to(loadingTag, {autoAlpha: 0, duration: (loadingFinTime * 0.001), delay: 0.4 });
	gsap.to(loadingTag, {clipPath: 'circle(0% at center)', duration: (loadingFinTime * 0.001), delay: 0.3, ease: "power4.out", onComplete: () => {
		//$(loadingTag).css({'display':'none'});
		initAnime_Page();
	}}); */

	/* gsap.to(loadingTag, {autoAlpha: 0, duration: (loadingFinTime * 0.001), delay: 0.1, overwrite: true });
	gsap.to(loadingTag, {clipPath: 'circle(0% at center)', duration: (loadingFinTime * 1.001), delay: 0.1, ease: "power4.out", overwrite: true, onComplete: () => {
		//$(loadingTag).css({'display':'none'});
		initAnime_Page();
	}}); */
}


// LOAD IMG CHECK
const contentsInner = '#contents';
let loaded_imgs_cache = {};
let load_img_check_seek = 0;
function loadImgCheck(callback){
	
	let load_img_check_now = (++load_img_check_seek);
	let srcs = {};
	let imgs = $('img', $(contentsInner));
	
	//画像.
	imgs.each(function(){
		srcs[$(this).attr('src')] = true;
	});
	
	srcs = Object.keys(srcs);	//to array.	
	
	if(srcs.length <= 0){
		callback();
	}
	
	let cnt = 0;
	for(let ii=0;ii<srcs.length;ii++) {
		let src = srcs[ii];
		if(src in loaded_imgs_cache){
			cnt++;
			if(srcs.length <= cnt)
				setTimeout(function(){
					if(callback){
						callback();
					}
				}, load_img_check_seek == 1?500:0);
			continue;
		}
		loaded_imgs_cache[src] = true;
		
		let limg = new Image();
		limg.onload = limg.onerror = function(errorMsg){
			//if(errorMsg.type == 'error')
			//	console.log('errorMsg',errorMsg)
			
			cnt++;
			if(srcs.length <= cnt){
				if(load_img_check_now != load_img_check_seek)
					return;
				setTimeout(function(){
					if(callback){
						callback();
					}
				}, load_img_check_seek == 1?500:0);
			}
		};
		limg.src = src;
	}
}



export {showLoading,loadImgCheck}

